import { useEffect, useState } from "react";
import { EntmotivacionalCreate } from "./EntmotivacionalCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

export function EntmotivacionalNew(props) {
  const entmotivacional = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let entmotivacionalLength = entmotivacional.length;
  let currentSesion = entmotivacionalLength + 1;

  const [entmotivResp, setEntmotivResp] = useState(props.especialistaFullName);
  const [entmotivFecha, setEntmotivFecha] = useState(todayDate);
  const [entmotivObs, setEntmotivObs] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitEntmotivacional = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      entmotivResp,
      entmotivFecha,
      entmotivObs,
      tratamientoId,
      pacienteId
    );
    try {
      await EntmotivacionalCreate(
        entmotivResp,
        entmotivFecha,
        entmotivObs,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../entrevista-motivacional/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        <form id="formNewElement" onSubmit={submitEntmotivacional}>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="entmotivResp">Responsable</label>
              <div className="control">
                <input
                  className="input"
                  id="entmotivResp"
                  required
                  type="text"
                  value={entmotivResp}
                  onChange={(e) => setEntmotivResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="entmotivFecha">Fecha entrevista</label>
              <div className="control">
                <input
                  className="input"
                  id="entmotivFecha"
                  required
                  type="date"
                  value={entmotivFecha}
                  onChange={(e) => setEntmotivFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="field">
            <label htmlFor="entmotivObs">Observaciones</label>
            <div className="control">
              <textarea
                className="textarea"
                name="entmotivObs"
                id="entmotivObs"
                value={entmotivObs}
                onChange={(e) => setEntmotivObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id="actions">
        <button
          className="button is-link"
          form="formNewElement"
          type="submit"
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      </div>
    </>
  );
}
